module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-ExtraBold.046392a7.woff2";